export default class ImageCarousel extends HTMLElement {
  constructor() {
    super();
    // Initialize images property
    this.images = [];
    
    // Get images from attribute if available
    const imagesAttr = this.getAttribute("images");
    if (imagesAttr) {
      try {
        this.images = JSON.parse(imagesAttr);
      } catch (e) {
        console.error("Failed to parse images attribute:", e);
      }
    }

    // Track current slide position
    this.currentSlide = 0;
    this.slidesPerView = window.innerWidth < 768 ? 3 : 6;
  }

  connectedCallback() {
    this.render();
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize.bind(this));
  }

  handleResize() {
    const newSlidesPerView = window.innerWidth < 768 ? 3 : 6;
    if (this.slidesPerView !== newSlidesPerView) {
      this.slidesPerView = newSlidesPerView;
      this.render();
    }
  }

  render() {
    this.innerHTML = "";

    // Create carousel wrapper
    const carouselWrapper = document.createElement("div");
    carouselWrapper.className = "relative w-full overflow-hidden my-3 md:my-6";

    // Create carousel track
    const track = document.createElement("ul");
    track.className = "flex transition-transform duration-300 ease-in-out";
    track.style.transform = `translateX(-${this.currentSlide * (100 / this.slidesPerView)}%)`;

    // Calculate item width based on slides per view
    const itemWidth = 100 / this.slidesPerView;

    this.images.forEach((item, index) => {
      const listItem = document.createElement("li");
      listItem.className = "flex-shrink-0 px-2";
      listItem.style.width = `${itemWidth}%`;

      const image = document.createElement("img");
      image.src = item.url;
      image.alt = item.alt || `Carousel image ${index + 1}`;
      image.className = "lazyload rounded-md w-full h-[20rem] md:h-[26rem] object-contain";

      listItem.appendChild(image);
      track.appendChild(listItem);
    });

    // Create navigation buttons
    const prevButton = document.createElement("button");
    prevButton.className = "absolute left-0 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-r-md z-10";
    prevButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>`;
    prevButton.addEventListener("click", () => this.prevSlide());

    const nextButton = document.createElement("button");
    nextButton.className = "absolute right-0 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-l-md z-10";
    nextButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>`;
    nextButton.addEventListener("click", () => this.nextSlide());

    // Add elements to DOM
    carouselWrapper.appendChild(track);
    carouselWrapper.appendChild(prevButton);
    carouselWrapper.appendChild(nextButton);
    this.appendChild(carouselWrapper);
    
    this.lazyLoadImages();
  }

  lazyLoadImages() {
    // Implementation for lazy loading images if needed
  }

  nextSlide() {
    const maxSlide = Math.max(0, this.images.length - this.slidesPerView);
    this.currentSlide = Math.min(this.currentSlide + 1, maxSlide);
    this.updateSlidePosition();
  }

  prevSlide() {
    this.currentSlide = Math.max(0, this.currentSlide - 1);
    this.updateSlidePosition();
  }

  updateSlidePosition() {
    const track = this.querySelector('ul');
    if (track) {
      track.style.transform = `translateX(-${this.currentSlide * (100 / this.slidesPerView)}%)`;
    }
  }
}
